import axios from 'axios';
import { makeConfig } from '../helpers/Helper';

export type ApiConfig = {
  apiDomain: string;
  apiUrl: string;
  socketUrl: string;
};

const apiUrlConfig = makeConfig();

const ApiClient = axios.create({
  baseURL: apiUrlConfig.apiUrl,
});

ApiClient.interceptors.request.use(
  (config) => {
    const newConfig = config;
    const userJSON = localStorage.getItem('user');
    if (userJSON) {
      try {
        const user = JSON.parse(userJSON);
        if (user?.accessToken && newConfig?.headers) {
          newConfig.headers.Authorization = `Bearer ${user?.accessToken}`;
        }
      } catch (e) {
        console.log(e); // todo: remove this line
      }
    }
    return newConfig;
  },
  (error) => Promise.reject(error)
);

ApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error?.response?.status) {
      return Promise.reject(new Error('Отсутствует сеть, попробуйте позже'));
    }
    if (error?.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.hash = '#/signIn';
    }
    return Promise.reject(error);
  }
);

export default ApiClient;
